// extracted by mini-css-extract-plugin
export default {"Nutrition__title":"Nutrition_Nutrition__title__37iv9","Nutrition__filter":"Nutrition_Nutrition__filter__325FA"};